import Content from '../../assets/help_page_content.md'
import '../styles/style.scss'
import { fluentAccordion, fluentAccordionItem, provideFluentDesignSystem } from '@fluentui/web-components'

provideFluentDesignSystem().register(fluentAccordion(), fluentAccordionItem())

const hideTemplates = () => {
  if (Office.context?.diagnostics?.platform === Office.PlatformType.OfficeOnline) {
    // The templates don't work properly in the web version of Excel
    // so we simply hide them completely. Note that we don't do this
    // on the DOM load because we can't be 100% sure at that time
    // which version we're running in.
    const templatesButton = document.getElementById('templates')
    templatesButton?.classList.add('hidden')
  }
}

const templatePrefix = 'template:'
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('help-container')
  container!.querySelector('fluent-accordion')!.innerHTML = Content

  container!.addEventListener('click', event => {
    const target = event.target as HTMLElement
    const anchorElement = target as HTMLAnchorElement
    const id = anchorElement.getAttribute('id')
    if (id?.startsWith(templatePrefix)) {
      // If it's a template link we want to open the template as a new
      // workbook if we're on Mac or Windows. If we're on the web
      // version won't be showing these links in the first place (see
      // above)
      const template = id.replace(templatePrefix, '')
      Excel.run(async () => {
        const url = `https://help.cognitivecredit.com/hubfs/Knowledge%20Base/Downloads/Templates/${template}.xlsx`
        const response = await fetch(url)
        const blob = await response.blob()
        const reader = new FileReader()
        reader.onload = async function () {
          // @ts-ignore
          const base64 = this?.result?.split(',')[1]
          Excel.createWorkbook(base64)
        }
        reader.readAsDataURL(blob)
      })
    } else if (Office.context.diagnostics.platform === Office.PlatformType.OfficeOnline) {
      // If we're on the web version of the UI and looking at any
      // other sort of link, we want in to open in a new browser
      // window / tab where it can sensibly display (and in the case
      // of e-mail / telephone links, where it has a chance of finding
      // an appropriate app. Hence we also need to prevent the default
      // action otherwise it'll still open up the same content in the
      // taskpane where it doesn't render nicely.
      const href = anchorElement.getAttribute('href')
      if (href) {
        window.open(href, '_blank')?.focus()
        event.preventDefault()
      }
    }
  })
})
Office.onReady(() => {
  hideTemplates()
})
